const CheckBox = ({id, className, label, checked, disabled, event}) => {
  return (
    <div className={`commonCheckbox ${className || ""}`}>
      <input
        id={id}
        className="checkboxInput"
        key={id}
        defaultChecked={checked}
        type="checkbox"
        disabled={disabled}
        hidden={true}
        onChange={event}
      />
      <label htmlFor={id} className="checkboxLabel d-flex a-center j-left">
        <span className="mr-5"></span>
        <p id={`${id}P`}>{label}</p>
      </label>
    </div>
  );
};

export default CheckBox;